import React from "react";
import { MeOutput, GetProfileQuery } from "@graphql";

export const LoggedInUserContext = React.createContext<
  (MeOutput & { profile: GetProfileQuery['profiles_by_pk'] }) | undefined
>(undefined);
